import { SocialLinks } from "../components/blocks/social-links";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" && staticType === "Social Links";

const create = (_data: { __typename: string }): JSX.Element => {
  return <SocialLinks />;
};

export default { test, create };
